import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW7001Model } from '../kymw7001.model';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { TargetListInfo } from '../vo/target_list_info.model';
import { KYMW0300OutputModel } from 'src/app/commons/kymw03/kymw0300/vo/kymw0300-output.model';

// レスポンス構造
export type GetTargetListByFeatureGoodsSelectionResponse = {
  PCode: string;
  ItemCode: string;
  GuideGoodsName: string;
  GuideStandardName: string;
  ClassCode: string;
  ClassNameKanji: string;
  LargeClassCode: string;
  LargeClassNameKanji: string;
  MiddleClassCode: string;
  MiddleClassNameKanji: string;
  SmallClassCode: string;
  SmallClassNameKanji: string;
  TagName: string;
  SupplyPriceStandard: string;
  SupplyPriceSpecial1: string;
  SupplyPriceSpecial2: string;
  CostPriceStandard: string;
  CostPriceSpecial1: string;
  CostPriceSpecial2: string;
}[];

/**
 * 商品情報取得(表紙特集掲載商品選定)サービス
 * @export GetTargetListByFeatureGoodsSelectionService
 * @class GetTargetListByFeatureGoodsSelectionService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetTargetListByFeatureGoodsSelectionService extends PlessJsonResponderSub<GetTargetListByFeatureGoodsSelectionResponse> {
  model: KYMW7001Model;
  outputModel: KYMW0300OutputModel;
  private calbak: (data: GetTargetListByFeatureGoodsSelectionResponse) => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetTargetListByFeatureGoodsSelectionService
   */
  private getBody(): PlessRequest {
    let combinationList = [];
    let searchObj = {};
    
    if (this.outputModel.pcodeList.length > 0) {
      // Pコードリスト検索
      this.outputModel.pcodeList.map((item) => {
        const addItem = {
          parameter: {
            TagId: "",
            GoodsMark: "",
            CoopCode: "",
            CatalogCode: "",
            GuideGoodsName: "",
            GuideStandardName: "",
            PageNo: "",
            Duties: "",
            PCode: item,
            ItemCode: "",
          }
        }
        combinationList.push(addItem);
      })
    } else if (this.outputModel.itemcodeList.length > 0) {
      // アイテムコードリスト検索
      this.outputModel.itemcodeList.map((item) => {
        const addItem = {
          parameter: {
            TagId: "",
            GoodsMark: "",
            CoopCode: "",
            CatalogCode: "",
            GuideGoodsName: "",
            GuideStandardName: "",
            PageNo: "",
            Duties: "",
            PCode: "",
            ItemCode: item,
          }
        }
        combinationList.push(addItem);
      })
    } else {
      const tagId = this.outputModel.tagId;
      const goodsMark = this.outputModel.goodsMark;
      const coopCodeList = this.outputModel.coopCodeList;
      const catalogCode = this.outputModel.catalogCode;
      const guideGoodsNameList = this.outputModel.guideGoodsNameList;
      const guideStandardNameList = this.outputModel.guideStandardNameList;
      const pageNo = this.outputModel.pageNo;
      const duties = this.outputModel.duties;

      const maxLength = Math.max(tagId.length, goodsMark.length, coopCodeList.length, catalogCode.length,
        guideGoodsNameList.length, guideStandardNameList.length, pageNo.length, duties.length);

      combinationList = Array.from({ length: maxLength }, (_, index) => ({
        parameter: {
          TagId: tagId[index] !== undefined ? tagId[index] : "",
          GoodsMark: goodsMark[index] !== undefined ? goodsMark[index] : "",
          CoopCode: coopCodeList[index] !== undefined ? coopCodeList[index] : "",
          CatalogCode: catalogCode[index] !== undefined ? catalogCode[index] : "",
          GuideGoodsName: guideGoodsNameList[index] !== undefined ? guideGoodsNameList[index] : "",
          GuideStandardName: guideStandardNameList[index] !== undefined ? guideStandardNameList[index] : "",
          PageNo: pageNo[index] !== undefined ? pageNo[index] : "",
          Duties: duties[index] !== undefined ? duties[index] : "",
          PCode: "",
          ItemCode: "",
        }
      }))
    }

    searchObj = {
      Rec: {
        parameter: {
          PCode: this.outputModel.pcode,
          ItemCode: this.outputModel.itemCode,
          JanCode: this.outputModel.janCode,
          MakerName: this.outputModel.makerName,
          TagSearchType: this.outputModel.tagSearchType,
          GoodsMarkSearchType: this.outputModel.goodsMarkSearchType,
          DataKbnFlg: this.outputModel.dataKbnFlg,
          GoodsDiv: this.outputModel.goodsDiv,
          BuyerCode: this.outputModel.buyerCode,
          AdmitStatus: this.outputModel.admitStatus,
          RegistDateFrom: this.outputModel.registDateFrom,
          RegistDateTo: this.outputModel.registDateTo,
          UpdateDateFrom: this.outputModel.updateDateFrom,
          UpdateDateTo: this.outputModel.updateDateTo,
          ClassCode: this.outputModel.classCode,
          MiddleClassCode: this.outputModel.middleClassCode,
          SmallClassCode: this.outputModel.smallClassCode,
          OrdrClientCode: this.outputModel.ordrClientCode,
          OrdrClientKanji: this.outputModel.ordrClientKanji,
          PayeeClientCode: this.outputModel.payeeClientCode,
          PayeeClientKanji: this.outputModel.payeeClientKanji,
          MediumType: this.outputModel.mediumType,
          OrderCode: this.outputModel.orderCode,
          StartOrderCode: this.model.orderCode,
          SpecialFeature: this.outputModel.specialFeature,
          CatalogCodeSearchType: this.outputModel.catalogCodeSearchType,
        },
        combination: combinationList
      }
    }
    return new PlessRequest({ search: searchObj });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetTargetListByFeatureGoodsSelectionService
   */
  execute(model: KYMW7001Model, outputModel: KYMW0300OutputModel ,f?: (data: GetTargetListByFeatureGoodsSelectionResponse) => void): void {
    this.model = model;
    this.outputModel = outputModel;
    if (f) this.calbak = f;
    this.send('KYMW70getTargetListByFeatureGoodsSelection', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetTargetListByFeatureGoodsSelectionService
   */
  success(data: GetTargetListByFeatureGoodsSelectionResponse) {
    const updateList = [];
    data.map(item => {
      const addData = new TargetListInfo();
      addData.check = false;
      addData.pCode = item.PCode;
      addData.itemCode = item.ItemCode;
      addData.guideGoodsName = item.GuideGoodsName;
      addData.guideStandardName = item.GuideStandardName;
      addData.classCode = item.ClassCode;
      addData.classNameKanji = item.ClassNameKanji;
      addData.largeClassCode = item.LargeClassCode;
      addData.largeClassNameKanji = item.LargeClassNameKanji;
      addData.middleClassCode = item.MiddleClassCode;
      addData.middleClassNameKanji = item.MiddleClassNameKanji;
      addData.smallClassCode = item.SmallClassCode;
      addData.smallClassNameKanji = item.SmallClassNameKanji;
      addData.tagName = item.TagName;
      addData.supplyPriceStandard = item.SupplyPriceStandard;
      addData.supplyPriceSpecial1 = item.SupplyPriceSpecial1;
      addData.supplyPriceSpecial2 = item.SupplyPriceSpecial2;
      addData.costPriceStandard = item.CostPriceStandard;
      addData.costPriceSpecial1 = item.CostPriceSpecial1;
      addData.costPriceSpecial2 = item.CostPriceSpecial2;
      updateList.push(addData)
    })
    this.model.TargetListInfo = updateList;

    if (this.calbak) this.calbak(data);
  }

  /**
   * 業務エラー時のメソッド
   * @param errList サーバ受信データ
   * 機能独自の処理を行う場合、このメソッドをオーバーライドして処理を実装する。
   */
  public plessErrorHandler(errList: Object): void {
    super.plessErrorHandler(errList);
  }

  /**
   * 特殊なエラーが返ってきた場合に呼び出されるメソッド。<br/>
   * 機能独自のステータスコードを持つ場合、このメソッドをオーバーライドして処理を実装する。
   */
  public exceptionError(status: string, result: any): void {
    super.exceptionError(status, result);
  }
}
